import { Component, inject } from '@angular/core';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import { DocumentsInformationForm } from './forms/documents-information.form';
import { stages } from '../../documents-information.routes';
import { ApplicationCommonComponent } from '../../../common/application.common.component';

@Component({
  selector: 'app-documents-information-section',
  standalone: true,
  imports: [
    StagesComponent,
    CommonModule,
    ReactiveFormsModule,
    SpinnerComponent,
    ValidationErrorsComponent
  ],
  providers: [DocumentsInformationForm],
  templateUrl: './documents-information-section.component.html'
})
export class DocumentsInformationSectionComponent extends ApplicationCommonComponent {

  public stages: string[] = stages;

  public successUrl: string = this.route.snapshot.data['successUrl'];

  public form: DocumentsInformationForm = inject(DocumentsInformationForm);

  public override onFetchApplicationData = (app: ApplicationAppEntityApplicationRead | null) => {
    if (app) {
      this.form.patchFormValues(app);
    }
  };

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.updateApplication(this.successUrl.replaceAll('../', ''), this.form.value);
    } else {
      this.form.markAllAsTouched();
    }
  }

  public override onCancel(): void {
    this.router.navigate(['../dane-wniosku'], { relativeTo: this.route });
  }
}
